import React from 'react'
import ReactWOW from 'react-wow'
import {StaticQuery, graphql} from 'gatsby'

import Button from 'src/components/ui/Button'
import * as S from './styled'

const PostContent = ({date, timeToRead, html, description, title}) => {
    return (
        <StaticQuery
            query={graphql `query { divisorImg: file(relativePath: { eq: "trumps/lotus-y.png"}){ childImageSharp { fluid(maxWidth: 80){ ...GatsbyImageSharpFluid } } } } `}
            render={data => (
            <S.PostWrapper>
                <S.PostHeader>
                    <S.PostLinkBack to="/blog/">
                        <Button color={`primary`} size={`sm`} variant={`outline`}>
                            {`← Voltar para blog`}
                        </Button>
                    </S.PostLinkBack>
                    <ReactWOW animation='fadeInUp'>
                        <S.PostDate>
                            {date}
                            • {timeToRead}
                            min de leitura
                        </S.PostDate>
                    </ReactWOW>
                    <ReactWOW animation='fadeInUp'>
                        <S.PostTitle>{title}</S.PostTitle>
                    </ReactWOW>
                    <ReactWOW animation='fadeInUp'>
                        <S.PostDescription>{description}</S.PostDescription>
                    </ReactWOW>
                </S.PostHeader>
                <S.PostDivisor fluid={data.divisorImg.childImageSharp.fluid}/>
                <ReactWOW animation='fadeIn' delay='0.2s'>
                    <S.MainContent>
                        <div
                            dangerouslySetInnerHTML={{
                            __html: html
                        }}></div>
                    </S.MainContent>
                </ReactWOW>
                <S.PostSignature>
                    <S.PostSignatureImg
                        src="https://avatars1.githubusercontent.com/u/9900252?s=460&v=4"/>
                    <S.PostSignatureCaption>
                        <S.PostSignatureTitle>
                            written by
                            <span>Vitor Régis</span>
                        </S.PostSignatureTitle>
                        <S.PostSignatureDesc>
                            {`Founder & DEV na Evolve. Integralmente, um jovem apaixonado por tecnologia e um
                            espiritualista em busca da evolução e paz interior.`}
                        </S.PostSignatureDesc>
                    </S.PostSignatureCaption>
                </S.PostSignature>
            </S.PostWrapper>
        )}/>
    )
}

export default PostContent;